/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import useScrollToTop from "../../../../Hooks/useScrollToTop";

const Footer = () => {
  const scrollToTop = useScrollToTop();

  return (
    <footer className="modern-footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <Link to="/" className="footer-logo" onClick={scrollToTop}>
                <p
                  style={{
                    color: "#e31e24",
                    fontWeight: "800",
                    fontSize: "1.5rem",
                    letterSpacing: "0.05em",
                    margin: 0,
                    fontFamily:
                      "'Bebas Neue', 'Impact', 'Arial Black', sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  BALOTAZH.COM
                </p>
              </Link>

              <p className="footer-description">
                Burimi kryesor i lajmeve të besueshme dhe të përditësuara për
                Kosovën dhe rajonin.
              </p>

              <div className="footer-social">
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Kategoritë</h4>
              <ul>
                <li>
                  <Link to="/category/lajme" onClick={scrollToTop}>
                    <i className="fas fa-newspaper"></i>
                    Lajme
                  </Link>
                </li>
                <li>
                  <Link to="/category/politikë" onClick={scrollToTop}>
                    <i className="fas fa-landmark"></i>
                    Politikë
                  </Link>
                </li>
                <li>
                  <Link to="/category/ekonomi" onClick={scrollToTop}>
                    <i className="fas fa-chart-line"></i>
                    Ekonomi
                  </Link>
                </li>
                <li>
                  <Link to="/category/sport" onClick={scrollToTop}>
                    <i className="fas fa-futbol"></i>
                    Sport
                  </Link>
                </li>
                <li>
                  <Link to="/category/teknologji" onClick={scrollToTop}>
                    <i className="fas fa-microchip"></i>
                    Teknologji
                  </Link>
                </li>
                <li>
                  <Link to="/category/kulturë" onClick={scrollToTop}>
                    <i className="fas fa-theater-masks"></i>
                    Kulturë
                  </Link>
                </li>
                <li>
                  <Link to="/category/shëndetësi" onClick={scrollToTop}>
                    <i className="fas fa-heartbeat"></i>
                    Shëndetësi
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-links">
              <h4>Shërbime</h4>
              <ul>
                <li>
                  <Link to="/about" onClick={scrollToTop}>
                    <i className="fas fa-info-circle"></i>
                    Rreth Nesh
                  </Link>
                </li>

                <li>
                  <Link to="/contact">
                    <i className="fas fa-envelope"></i>
                    Na Kontaktoni
                  </Link>
                </li>

                <li>
                  <Link to="/privacy" onClick={scrollToTop}>
                    <i className="fas fa-shield-alt"></i>
                    Privatësia
                  </Link>
                </li>
                {/* <li>
                    <Link to="/terms">
                      <i className="fas fa-file-contract"></i>
                      Kushtet e Përdorimit
                    </Link>
                  </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 Balotazhi. Të gjitha të drejtat e rezervuara.</p>
            </div>
            <div className="made-with-love">
              <p>
                Zhvilluar me <i className="fas fa-heart"></i> në Kosovë
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
